import { Field, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { Project } from '../Project'
import type { IAction } from '../../action/IAction'
import GraphQLJSON from 'graphql-type-json'
import type { Task } from '../../task/Task'

@InputType()
export class CreateProjectAndTasksArgs extends ActionArgs {
  @Field(() => GraphQLJSON)
  input: Project
}

@InputType()
export class CreateProjectAndTasksResult extends ActionArgs {
  @Field(() => GraphQLJSON)
  tasks: Task[]

  @Field(() => GraphQLJSON)
  newProject: Project
}

export interface ICreateProjectAndTasksService extends IAction<CreateProjectAndTasksResult, CreateProjectAndTasksArgs> {}
